module.exports = __webpack_public_path__ + "img/marker-gray.99f7d432.svg";